import { render } from "./CardFooter.vue?vue&type=template&id=551a4b94&scoped=true"
import script from "./CardFooter.vue?vue&type=script&lang=js"
export * from "./CardFooter.vue?vue&type=script&lang=js"

import "./CardFooter.vue?vue&type=style&index=0&id=551a4b94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551a4b94"]])

export default __exports__